import React, {useState, useEffect } from 'react';
import { 
         Button,
         Divider,
         Grid,
         CircularProgress,
         LinearProgress,
         Paper,
         TextField,
        } from '@material-ui/core';
import { 
            Send as SendIcon,
            //Search as SearchIcon,
        } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { SnackbarProvider, useSnackbar } from 'notistack';
//import { makeStyles } from '@material-ui/core/styles';
import { useAuth } from "../Auth";
//import Swal from 'sweetalert2';
import { Tooltip as TooltipAntd } from 'antd';

function Backup(){
    const { authTokens } = useAuth(); 
    const { enqueueSnackbar } = useSnackbar();
    const [ dataZona, setDataZona ] = useState([]);
    const [ isProcessing, setProcessing ] = useState(false);
    const [ isProcessingDB, setProcessingDB ] = useState(false);
    const [ zonaCliente, setZonaCliente ] = useState('');

    
    /************************************************************************/
    useEffect(
        ()=>{
            async function ReqInfo() {
                const dataZonas = await fetch('/api/Zonas');
                const resultZonas = await dataZonas.json();
                if(authTokens.Type === 'ADMINISTRADOR'){
                    setDataZona(resultZonas);
                }else{              
                    const ZonasArr = authTokens.Zonas.map(valZon=> valZon.Zona);
                    const arrFilZona = resultZonas.filter(value=> ZonasArr.includes(value.Zona.toString()))
                    setDataZona(arrFilZona);
                } 
            };
        
            ReqInfo();
        },[] // eslint-disable-line react-hooks/exhaustive-deps
    );


    const handleSelectZona2 = (e, value, reason)=>{
        if(reason ===  'clear'){
            setZonaCliente('');
        }else{
            setZonaCliente(value);
        }
    };

    const handleBackup = ()=>{
        setProcessing(true);
        const objeto = {};
        const filterZona = dataZona.filter(el=> el.Zona === zonaCliente)[0];
            objeto.INFOZONA = filterZona;
        fetch('api/mikrotik/backups',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            setProcessing(false);
            if(result.message){
                enqueueSnackbar(result.message,{variant:'success'});
            }else{
                enqueueSnackbar(result.status,{variant:'error'});
            }
        });
    };

    const handleBackupDB = async ()=>{
        setProcessingDB(true);
        const fetchBackup = await fetch('/api/Backup/MongoDB');
        const jsonBackup  = await fetchBackup.json();
        setProcessingDB(false);
        if(jsonBackup.message){
            enqueueSnackbar(jsonBackup.message,{variant:'success'});
        }else{
            enqueueSnackbar(jsonBackup.status,{variant:'error'});
        }
    };


    return(
        <Grid container spacing={1} style={{padding:50, width:'100%'}} justifyContent='center' alignItems='flex-start'>
            <Grid item xl={5} lg={5} md={8} sm={12} xs={12} style={{alignSelf: 'flex-start', height:300, marginTop:100}}>
                <Paper elevation={3} style={{padding:15, width:'100%'}}>
                    <Grid container spacing={3} justifyContent='center'>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} style={{height:5}}>
                            {isProcessing   &&  <LinearProgress color='secondary' /> }
                            {isProcessingDB &&  <LinearProgress color='secondary' /> }
                        </Grid>
                        <Grid item xs={8}> 
                            <Autocomplete
                                id="Zona"
                                options={dataZona.map(value=>value.Zona)}
                                value={zonaCliente || ''}                              
                                renderInput={(params) => <TextField {...params} label="Zona" variant="outlined" size='small' fullWidth color='primary'/>}
                                onChange={handleSelectZona2} 
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TooltipAntd color='lime' title='CREAR BACKUP'>
                                <span>
                                <Button 
                                    fullWidth 
                                    size='medium' 
                                    variant="contained" 
                                    color='primary' 
                                    disabled={isProcessing}
                                    endIcon={
                                        isProcessing 
                                        ? <CircularProgress size={20} color='primary'/> 
                                        : <SendIcon />
                                    } 
                                    onClick={handleBackup}
                                >
                                    BACKUP
                                </Button>
                                </span>
                            </TooltipAntd>
                        </Grid>        
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>  
                        <Grid item xs={12}>
                            <Grid container justifyContent='center' alignItems="center">
                                <Grid item xs={12} sm={10} md={6}>
                                <TooltipAntd color='purple' title='CREAR BACKUP DB'>
                                    <span>
                                    <Button 
                                        fullWidth 
                                        size='medium' 
                                        variant="contained" 
                                        color='primary' 
                                        disabled={isProcessingDB}
                                        endIcon={
                                            isProcessingDB 
                                            ? <CircularProgress size={20} color='primary'/> 
                                            : <SendIcon />
                                        } 
                                        onClick={handleBackupDB}>
                                        BACKUP DB
                                    </Button>
                                    </span>
                                </TooltipAntd>
                                </Grid>
                            </Grid>
                        </Grid>             
                    </Grid>   
                </Paper>
            </Grid>
        </Grid>
    );
};

function Backups(){
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense >
          <Backup />
        </SnackbarProvider>
    );
};

export default Backups;